import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import StartTime from "./StartTime.js";
const useStyles = makeStyles((theme) => ({}));
function Hourly(props) {
  const [value, setValue] = useState(1);
  const classes = useStyles();
  const [startTime, setStartTime] = useState({ minutes: 0 });
  const returnValue = (newValue) => {
    setValue(newValue);
    props.returnValue(newValue, startTime);
  };

  const returnStartTime = (time) => {
    setStartTime(time);
    props.returnValue(value, time);
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", marginTop: 20 }}>
      <div>
        <TextField
          id="outlined-number"
          label="Every hour(s)"
          value={value}
          onChange={(e) =>
            e.target.value <= 23 &&
            e.target.value >= 1 &&
            returnValue(e.target.value)
          }
          type="number"
          margin="normal"
          variant="outlined"
        />
      </div>
      <StartTime minuteOnly returnValue={returnStartTime} />
    </div>
  );
}

export default Hourly;
